import { z } from 'zod';

export enum PrototypeVersionMappingState {
    PUBLISHED_IN_PREVIOUS_VERSION = 'PUBLISHED_IN_PREVIOUS_VERSION',
    OPEN = 'OPEN',
    PUBLISHED = 'PUBLISHED',
    LOCKED = 'LOCKED',
}

export const PrototypeVersionMappingStateSchema = z.enum(PrototypeVersionMappingState);
